<template>
    <div>
        <div class="filter-container">
            <div>
                <palm-multiple-edit :is-batch-edit="isBatchEdit" />
            </div>

            <table-action-button
                :is-add="true"
                :is-add-multi-permission="false"
                :is-export="false"
                :is-batch-delete="false"
                :is-print-qr="true"
                :is-filter="true"
                @addNew="addNew"
                @refreshTable="refreshTable"
                @filterData="handleFilterData"
                @printQRCode="printQRCode"
            />
        </div>

        <general-filter-chip />

        <agrinome-table
            ref="palm-table"
            :key="tableKey"
            :api-mode="true"
            :columns="columns"
            :selection-row.sync="selectionRow"
            :current-row.sync="currentRow"
            :http-options="httpOptions"
            :api-url="apiUrl"
            :append-params="appendParams"
            :column-search-bool="columnSearchBool"
            :inline-edit="false"
            @handle-edit="handleEdit"
            @handle-delete="handleDelete"
            @filter-change="filterChange"
            @handle-row-click="handleRowClick"
        />

        <general-dialog :is-dialog.sync="isFilterDialog" :title="filterDialogTitle" :dialog-width="dialogWidth" :is-auto-close-after-submit="false" @handleConfirm="handleApplyFilter()">
            <template #content>
                <el-form ref="form" :model="filter" status-icon>
                    <el-form-item class="form-item-darwin" label="Program">
                        <form-select 
                            :input-value.sync="recordFilter.Program.value"
                            :options="programOpts"
                        />
                    </el-form-item>
                    
                    <el-form-item class="form-item-darwin" label="Trial">
                        <form-select 
                            :input-value.sync="recordFilter.Trial.value"
                            :options="trialOpts"
                        />
                    </el-form-item>
                    
                    <el-form-item class="form-item-darwin" label="Progeny">
                        <form-select 
                            :input-value.sync="recordFilter.Progeny.value"
                            :options="progenyOpts"
                        />
                    </el-form-item>
                   
                    <el-form-item class="form-item-darwin" label="Germplasm">
                        <form-select 
                            :input-value.sync="recordFilter.Germplasm.value"
                            :options="germplasmOpts"
                        />
                    </el-form-item>

                    <el-form-item class="form-item-darwin" label="Palm Number">
                        <form-input
                            :input-value.sync="recordFilter.TrialPalmNumber.value"
                            :is-number="true"
                        />
                    </el-form-item>
                    
                    <el-form-item class="form-item-darwin" label="Cross Type">
                        <form-select 
                            :input-value.sync="recordFilter.CrossType.value"
                            :options="crossTypeOpts"
                        />
                    </el-form-item>

                    <el-form-item class="form-item-darwin" label="Fruit Type">
                        <form-select 
                            :input-value.sync="recordFilter.FruitType.value"
                            :options="fruitTypeOpts"
                        />
                    </el-form-item>

                    <el-form-item class="form-item-darwin" label="Palm Status">
                        <form-select 
                            :input-value.sync="recordFilter.PalmStatus.value"
                            :options="palmStatusOpts"
                        />
                    </el-form-item>
                    
                    <el-form-item class="form-item-darwin" label="Palm Availability">
                        <form-select 
                            :input-value.sync="recordFilter.PalmAvailability.value"
                            :options="palmAvailabilityOpts"
                        />
                    </el-form-item>
                   
                    <el-form-item class="form-item-darwin" label="Palm Characteristic">
                        <form-select 
                            :input-value.sync="recordFilter.PalmCharacteristic.value"
                            :options="palmCharacteristicOpts"
                        />
                    </el-form-item>
                   
                    <el-form-item class="form-item-darwin" label="Palm Description">
                        <form-select 
                            :input-value.sync="recordFilter.PalmDescription.value"
                            :options="palmDescriptionOpts"
                        />
                    </el-form-item>
                   
                    <el-form-item class="form-item-darwin" label="Palm Classification">
                        <form-select 
                            :input-value.sync="recordFilter.PalmClassification.value"
                            :options="palmClassificationOpts"
                        />
                    </el-form-item>
                    
                    <el-form-item class="form-item-darwin" label="Is Standard Cross">
                        <form-select 
                            :input-value.sync="recordFilter.IsStandardCross.value"
                            :options="standardCrossOpts"
                        />
                    </el-form-item>
                    
                    <el-form-item class="form-item-darwin" label="Is Contaminated">
                        <form-select 
                            :input-value.sync="recordFilter.IsContaminated.value"
                            :options="contaminatedOpts"
                        />
                    </el-form-item>
                </el-form>
            </template>
        </general-dialog>


        <general-dialog :is-dialog.sync="isNewOrEditDialog" :title="createOrEditDialogTitle" :dialog-width="dialogWidth" :is-auto-close-after-submit="false" @handleConfirm="saveNewOrEditDialog()">
            <template #content>
                <el-form ref="form" :model="palm" status-icon>
                    <div class="row">
                        <div class="col-12">
                            <el-form-item class="form-item-darwin" label="Trial Palm Number">
                                <form-input
                                    :input-value.sync="palm.trialPalmNumber"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-12">
                            <el-form-item class="form-item-darwin" label="Trial">
                                <form-select
                                    :input-value.sync="palm.trialId"
                                    :options="trialOpts"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-12">
                            <el-form-item class="form-item-darwin" label="Progeny">
                                <form-select
                                    :input-value.sync="palm.progenyId"
                                    :options="progenyOpts"
                                    placeholder="Progeny"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-4">
                            <el-form-item class="form-item-darwin" label="Fruit Type">
                                <form-select
                                    :input-value.sync="palm.fruitTypeId"
                                    :options="fruitTypeOpts"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-4">
                            <el-form-item class="form-item-darwin" label="Fruit Off Type">
                                <form-select
                                    :input-value.sync="palm.fruitOffTypeId"
                                    :options="fruitOffTypeOpts"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-4">
                            <el-form-item class="form-item-darwin" label="Fruit Color">
                                <form-select
                                    :input-value.sync="palm.fruitColorId"
                                    :options="fruitColourOpts"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-6">
                            <el-form-item class="form-item-darwin" label="Palm Availability">
                                <form-select
                                    :input-value.sync="palm.palmAvailabilityId"
                                    :options="palmAvailabilityOpts"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-6">
                            <el-form-item class="form-item-darwin" label="Palm Characteristic">
                                <form-select
                                    :input-value.sync="palm.palmCharacteristicId"
                                    :options="palmCharacteristicOpts"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-6">
                            <el-form-item class="form-item-darwin" label="Palm Classification">
                                <form-select
                                    :input-value.sync="palm.palmClassificationId"
                                    :options="palmClassificationOpts"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-6">
                            <el-form-item class="form-item-darwin" label="Palm Description">
                                <form-select
                                    :input-value.sync="palm.palmDescriptionId"
                                    :options="palmDescriptionOpts"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-4">
                            <el-form-item class="form-item-darwin" label="Block Number">
                                <form-input
                                    :input-value.sync="palm.blockNumber"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-4">
                            <el-form-item class="form-item-darwin" label="Plot Number">
                                <form-input
                                    :input-value.sync="palm.plotNumber"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-4">
                            <el-form-item class="form-item-darwin" label="Rep Number">
                                <form-input
                                    :input-value.sync="palm.repNumber"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-12">
                            <el-form-item class="form-item-darwin" label="Planting Density">
                                <form-input
                                    :input-value.sync="palm.plantingDensity"
                                    :is-required="true"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-12">
                            <el-form-item class="form-item-darwin" label="Is Active">
                                <form-boolean
                                    :input-value.sync="palm.isActive"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-12">
                            <el-form-item class="form-item-darwin" label="Remarks">
                                <form-input
                                    :input-value.sync="palm.remarks"
                                />
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </template>
        </general-dialog>

        <qr-card :id="qrCardContainerId" class="qr-hidden-container" :qr-info="qrInfo" />
    </div>
</template>

<script>
import moment from "moment";
import { palmCreate, palmUpdate, palmDelete } from "@/api/palm";
import TableActionButton from "@/components/Button/TableActionButton";
import GeneralDialog from "@/components/Dialog/GeneralDialog";
import { mapGetters } from "vuex";
import GeneralFilterChip from "@/components/Chip/GeneralFilterChip";
import FormSelect from "@/components/Form/FormSelect";
import MPOBPalmFormat from "@/components/Progeny/MPOBPalmFormat";
import { programGetAllForDropdown } from "@/api/program";
import { trialGetAllForDropdown } from "@/api/trial";
import { getAllFruitTypeOptions } from "@/api/fruit_type";
import { crossTypeAllForDropdown } from "@/api/cross_type";
import { getAllProgenyOptions } from "@/api/progeny";
import { germplasmGetAllForDropdown } from "@/api/germplasm";
import { palmAvailabilityGetAllForDropdown } from "@/api/palm_availability";
import { palmCharacteristicGetAllForDropdown } from "@/api/palm_characteristic";
import { palmClassificationGetAllForDropdown } from "@/api/palm_classification";
import { palmDescriptionGetAllForDropdown } from "@/api/palm_description";
import { palmStatusGetAllForDropdown } from "@/api/palm_status";
import { agenciesGetAllForDropdown } from "@/api/agency";
import { getAllFruitOffTypeOptions } from "@/api/fruit_off_type";
import { getAllFruitColourOptions } from "@/api/fruit_colour";
import QRCard from "@/components/QRCard/QRCard";
import FormInput from "@/components/Form/FormInput";
import FormBoolean from "@/components/Form/FormBoolean";
import PalmMultipleEdit from "@/components/Palm/PalmMultipleEdit";


function FilterBlueprint(name, label, value, compatator, isDisplayInChip, formatter) {
    this.name = name;
    this.label = label;
    this.value = value;
    this.compatator = compatator;
    this.isDisplayInChip = isDisplayInChip == null ? true : isDisplayInChip;
    this.formatter = formatter;
}

export default {
    components: {
        "table-action-button": TableActionButton,
        "general-dialog": GeneralDialog,
        "general-filter-chip": GeneralFilterChip,
        "form-select": FormSelect,
        "form-boolean": FormBoolean,
        "qr-card": QRCard,
        "form-input": FormInput,
        "palm-multiple-edit": PalmMultipleEdit,
    },
    props: {
        programId: {
            type: Number | String
        },
        trialId: {
            type: Number | String
        },
        progenyId: {
            type: Number | String
        },
        germplasmId: {
            type: Number | String
        },
    },
    data() {
        return {
            dateRange: "",
            tableId: "palm-table",
            currentRow: {},
            selectionRow: [],
            apiUrl: "/api/services/app/Palm/GetAll",
            tableKey: 1,

            filter: {},
            palm: {},

            dateFrom: null,
            dateTo: null,

            isDialog: false,
            dialogTitle: "Export File",
            dialogWidth: "50%",
            isExportWithMediaFile: false,

            isFilterDialog: false,
            filterDialogTitle: "Filter Data",

            recordFilter: {
                // name, label, value, compatator, isDisplayInChip, formatter
                Program: new FilterBlueprint("ProgramId", "Program", null, "=", true),
                Trial: new FilterBlueprint("TrialIds", "Trial", null, "=", true),
                Progeny: new FilterBlueprint("ProgenyId", "Progeny", null, "=", true),
                Germplasm: new FilterBlueprint("GermplasmId", "Germplasm", null, "=", true),
                FruitType: new FilterBlueprint("FruitTypeIds", "Fruit Type", null, "=", true),
                CrossType: new FilterBlueprint("CrossTypeIds", "Cross Type", null, "=", true),
                PalmStatus: new FilterBlueprint("PalmStatusIds", "Palm Status", null, "=", true),
                PalmAvailability: new FilterBlueprint("PalmAvailabilityIds", "Palm Availability", null, "=", true),
                PalmCharacteristic: new FilterBlueprint("PalmCharacteristicIds", "Palm Characteristic", null, "=", true),
                PalmDescription: new FilterBlueprint("PalmDescriptionIds", "Palm Description", null, "=", true),
                PalmClassification: new FilterBlueprint("PalmClassificationIds", "Palm Classification", null, "=", true),
                TrialPalmNumber: new FilterBlueprint("TrialPalmNumber", "Palm Number", null, "=", true),
                IsStandardCross: new FilterBlueprint("IsStandardCross", "Is Standard Cross", null, "=", true),
                IsContaminated: new FilterBlueprint("IsContaminated", "Is Contaminated", null, "=", true),
            },
                
            tableCustomFieldFilter: null,
            columnSearchBool: false,

            isNewOrEditDialog: false,
            isNew: true,
            customFieldFilter: null,

            programOpts: [],
            trialOpts: [],
            progenyOpts: [],
            germplasmOpts: [],
            fruitTypeOpts: [],
            fruitOffTypeOpts: [],
            crossTypeOpts: [],
            fruitColourOpts: [],
            standardCrossOpts: [
                { id: true, name: "Standard Cross", value: true },
                { id: false, name: "Not Standard Cross", value: false }
            ],
            contaminatedOpts: [
                { id: true, name: "Contaminted Palm (Wrong Expected Fruit Type)", value: true },
                { id: false, name: "Normal Palm", value: false }
            ],
            palmStatusOpts: [],
            palmAvailabilityOpts: [],
            palmCharacteristicOpts: [],
            palmDescriptionOpts: [],
            palmClassificationOpts: [],

            qrInfo: [],
            qrCardContainerId: "palm-table",

            isBatchEdit: false
        };
    },
    computed: {
        ...mapGetters([
            "generalFilter",
            "accessToken"
        ]),
        httpOptions() {
            return {
                baseUrl: process.env.ROOT_API,
                headers: {
                    "Authorization": "Bearer " + this.accessToken
                }
            };
        },
        appendParams() {
            let general_filter = {};

            if (this.generalFilter && this.generalFilter.length > 0) {
                this.generalFilter.forEach((item) => {
                    general_filter[item.name] = item.value; 
                });
            }
                
            return {
                "DateFrom": this.dateFrom,
                "DateTo": this.dateTo,
                "ProgramIds[0]": this.programId,
                "TrialIds[0]": this.trialId,
                "ProgenyId": this.progenyId,
                "GermplasmId": this.germplasmId,
                ...general_filter
            };
        },
        isAddPermission() {
            return this.$_isIncludePermission("Permissions.Darwin.Recordings.Create");
        },
        isEditPermission() {
            return this.$_isIncludePermission("Permissions.Darwin.Recordings.Edit");
        },
        isDeletePermission() {
            return this.$_isIncludePermission("Permissions.Darwin.Recordings.Delete");
        },
        columns() {
            return [
                {
                    name: "qrCode.code",
                    label: "QR Code",
                    sortable: "custom",
                    width: 130,
                    link: {
                        pageName: "PalmDetail",
                        linkId: "id"
                    }
                },
                {
                    name: "",
                    label: "Trial/Palm(Progeny)",
                    sortable: "custom",
                    width: 160,
                    customVueComponent: this.getMPOBPalmFormatComponent()
                },
                {
                    name: "fruitType.name",
                    label: "Fruit Type",
                    sortable: "custom",
                    width: 125,
                },
                {
                    name: "fruitColor.name",
                    label: "Fruit Colour",
                    sortable: "custom",
                    width: 125,
                },
                {
                    name: "fruitOffType.name",
                    label: "Fruit Off Type",
                    sortable: "custom",
                    width: 125,
                },
                {
                    name: "palmStatus.name",
                    label: "Palm Status",
                    sortable: "custom",
                    width: 100
                },
                {
                    name: "palmAvailability.name",
                    label: "Palm Availability",
                    sortable: "custom",
                    width: 100
                },
                {
                    name: "palmCharacteristic.name",
                    label: "Palm Characteristic",
                    sortable: "custom",
                    width: 100
                },
                // {
                //     name: "palmOriginMaterial.name",
                //     label: "Palm Origin Material",
                //     sortable: "custom",
                //     width: 100
                // },
                // {
                //     name: "palmGeneration.name",
                //     label: "Palm Generation",
                //     sortable: "custom",
                //     width: 100
                // },
                {
                    name: "palmDescription.name",
                    label: "Palm Description",
                    sortable: "custom",
                    width: 100
                },
                {
                    name: "palmClassification.name",
                    label: "Palm Classification",
                    sortable: "custom",
                    width: 100
                },
                {
                    name: "plotNumber",
                    label: "Plot Number",
                    sortable: "custom",
                    width: 100
                },
                {
                    name: "repNumber",
                    label: "Replicate Number",
                    sortable: "custom",
                    width: 100
                },
                {
                    name: "progeny.isStandard",
                    label: "Standard Cross",
                    sortable: "custom",
                    width: 100
                },
                {
                    name: "palmCalculatedData.bunchAnalysisCount",
                    label: "no. of Bunch Analysis (n)",
                    sortable: "custom",
                    width: 100
                },
                {
                    name: "palmCalculatedData.vegetativeMeasurementCount",
                    label: "no. of Vegetative Analysis (n)",
                    sortable: "custom",
                    width: 100
                },
                {
                    name: "palmCalculatedData.yieldRecordingCount",
                    label: "no. of Yield Recording Analysis (n)",
                    sortable: "custom",
                    width: 100
                },
                {
                    name: "palmCalculatedData.fattyAcidCount",
                    label: "no. of Fatty Acid Analysis (n)",
                    sortable: "custom",
                    width: 100
                },
                {
                    name: "creatorUser.userName",
                    label: "Creator User",
                    minWidth: "120",
                    sortable: "custom",
                    isDisableEdit: true
                },
                {
                    name: "creationTime",
                    label: "Creation Time",
                    minWidth: "180",
                    sortable: "custom",
                    formatter (row, col, cell, index) {
                        return moment(cell).local().format("lll");
                    },
                    isDisableEdit: true
                },
                {
                    name: "lastModifierUser.userName",
                    label: "Last Modifier User",
                    minWidth: "120",
                    sortable: "custom",
                    isDisableEdit: true
                },
                {
                    name: "lastModificationTime",
                    label: "Last Modification Time",
                    minWidth: "180",
                    sortable: "custom",
                    formatter (row, col, cell, index) {
                        return moment(cell).local().format("lll");
                    },
                    isDisableEdit: true
                }
            ];
        },
        createOrEditDialogTitle() {
            let isNew = this.isNew ? "New" : "Edit";
            return `${isNew} Palm`;
        },
    },
    watch: {
        isFilterDialog() {
            if (this.isFilterDialog)
            {
                if (!this.trialOpts || this.trialOpts.length == 0) this.getTrialOpts();
                if (!this.progenyOpts || this.progenyOpts.length == 0) this.getProgenyOpts();
                if (!this.germplasmOpts || this.germplasmOpts.length == 0) this.getGermplasmOpts();
                if (!this.fruitTypeOpts || this.fruitTypeOpts.length == 0) this.getFruitTypeOpts();
                if (!this.crossTypeOpts || this.crossTypeOpts.length == 0) this.getCrossTypeOpts();
                if (!this.programOpts || this.programOpts.length == 0) this.getProgramOpts();
                if (!this.palmStatusOpts || this.palmStatusOpts.length == 0) this.getPalmStatusOpts();
                if (!this.palmAvailabilityOpts || this.palmAvailabilityOpts.length == 0) this.getPalmAvailabilitys();
                if (!this.palmCharacteristicOpts || this.palmCharacteristicOpts.length == 0) this.getPalmCharacteristicOpts();
                if (!this.palmDescriptionOpts || this.palmDescriptionOpts.length == 0) this.getPalmDescriptionOpts();
                if (!this.palmClassificationOpts || this.palmClassificationOpts.length == 0) this.getPalmClassificationOpts();
            }
        },
        isNewOrEditDialog() {
            if (this.isNewOrEditDialog)
            {
                if (!this.programOpts || this.programOpts.length == 0) this.getProgramOpts();
                if (!this.trialOpts || this.trialOpts.length == 0) this.getTrialOpts();
                if (!this.crossTypeOpts || this.crossTypeOpts.length == 0) this.getCrossTypeOpts();
                if (!this.agencyOpts || this.agencyOpts.length == 0) this.getAgencyOpts();
                if (!this.progenyOpts || this.progenyOpts.length == 0) this.getProgenyOpts();
                if (!this.fruitTypeOpts || this.fruitTypeOpts.length == 0) this.getFruitTypeOpts();
                if (!this.fruitColourOpts || this.fruitColourOpts.length == 0) this.getFruitColourOpts();
                if (!this.fruitOffTypeOpts || this.fruitOffTypeOpts.length == 0) this.getFruitOffTypeOpts();
                if (!this.palmStatusOpts || this.palmStatusOpts.length == 0) this.getPalmStatusOpts();
                if (!this.palmAvailabilityOpts || this.palmAvailabilityOpts.length == 0) this.getPalmAvailabilitys();
                if (!this.palmCharacteristicOpts || this.palmCharacteristicOpts.length == 0) this.getPalmCharacteristicOpts();
                if (!this.palmDescriptionOpts || this.palmDescriptionOpts.length == 0) this.getPalmDescriptionOpts();
                if (!this.palmClassificationOpts || this.palmClassificationOpts.length == 0) this.getPalmClassificationOpts();

            }
        },
        selectionRow() {
            if (this.selectionRow.length > 0) {
                this.isBatchEdit = true;
            }
            else this.isBatchEdit = false;
        }
    },
    methods: {
        addNew() {
            this.isNew = true;
        
            this.palm = {};
            this.isNewOrEditDialog = true;
        },
        getMPOBPalmFormatComponent() {
            return MPOBPalmFormat;
        },
        refreshTable(totalLength) {
            this.$refs["palm-table"].refreshTable(totalLength);
        },
        async saveNewOrEditDialog() {
            if (this.isNew == true) this.createNewPalm();
            else this.editPalm();
        },
        async createNewPalm() {
            let res = await palmCreate(this.palm);
            if (res) {
                this.$_triggerSuccessNotify("Palm Created");
                this.isNewOrEditDialog = false;
                this.refreshTable();
            }
        },
        async editPalm() {
            let res = await palmUpdate(this.palm);
            if (res) {
                this.$_triggerSuccessNotify("Palm Edited");
                this.isNewOrEditDialog = false;
                this.refreshTable();
            }
        },
        handleApplyFilter() {
            var filterChips = [];
            Object.keys(this.recordFilter).forEach(key => {
                if (this.recordFilter[key].value) {
                    filterChips.push(this.recordFilter[key]);
                }
            });
            this.$store.dispatch("general_filter/applyGeneralFilter", filterChips);
            this.$nextTick(() => {
                this.isFilterDialog = false;
            });
        },
        clearRecordFilter() {
            Object.keys(this.recordFilter).forEach(key => {
                this.recordFilter[key].value = null;
            });
        },
        handleFilterData() {
            if (this.generalFilter && this.generalFilter.length > 0) {
                this.clearRecordFilter();
                
                Object.keys(this.recordFilter).forEach(key => {
                    this.generalFilter.forEach(item => {
                        if (key == item.name && this.recordFilter[key].value != item.value) {
                            this.recordFilter[key].value = item.value;
                        }
                    });
                });
            }
            this.isFilterDialog = true;
        },
        async filterChange() {
            this.refreshTable();
        },
        async handleEdit(index, row) {
            this.isNew = false;

            this.palm = row;
            this.isNewOrEditDialog = true;
        },
        async handleDelete(index, row) {
            var res = await palmDelete({ Id: row.id });
            if (res) {
                this.$_triggerSuccessNotify(`Row Deleted (ID: ${row.id})`);
                this.$store.dispatch("info_sidebar/setInfoSidebarObject", {});
                this.refreshTable();
            }
        },
        handleRowClick() {
            this.$_openSidebarWithChecking();
            this.$store.dispatch("info_sidebar/setInfoSidebarObject", {});
            this.$store.dispatch("info_sidebar/setInfoSidebarId", this.currentRow.id);
            this.$store.dispatch("info_sidebar/setInfoSidebarCategory", "PALM");
        },
        async getProgramOpts() {
            let res = await programGetAllForDropdown();
            if (res) {
                this.programOpts = res;
            }
        },
        async getTrialOpts() {
            let res = await trialGetAllForDropdown();
            if (res) {
                this.trialOpts = res;
            }
        },
        async getProgenyOpts() {
            let res = await getAllProgenyOptions();
            if (res) {
                this.progenyOpts = res;
            }
        },
        async getGermplasmOpts() {
            let res = await germplasmGetAllForDropdown();
            if (res) {
                this.germplasmOpts = res;
            }
        },
        async getFruitTypeOpts() {
            let res = await getAllFruitTypeOptions();
            if (res) {
                this.fruitTypeOpts = res;
            }
        },
        async getFruitOffTypeOpts() {
            let res = await getAllFruitOffTypeOptions();
            if (res) {
                this.fruitOffTypeOpts = res;
            }
        },
        async getFruitColourOpts() {
            let res = await getAllFruitColourOptions();
            if (res) {
                this.fruitColourOpts = res;
            }
        },
        async getCrossTypeOpts() {
            let res = await crossTypeAllForDropdown();
            if (res) {
                this.crossTypeOpts = res;
            }
        },
        async getPalmAvailabilitys() {
            let res = await palmAvailabilityGetAllForDropdown();
            if (res) {
                this.palmAvailabilityOpts = res;
            }
        },
        async getPalmCharacteristicOpts() {
            let res = await palmCharacteristicGetAllForDropdown();
            if (res) {
                this.palmCharacteristicOpts = res;
            }
        },
        async getPalmClassificationOpts () {
            let res = await palmClassificationGetAllForDropdown();
            if (res) {
                this.palmClassificationOpts = res;
            }
        },
        async getPalmDescriptionOpts() {
            let res = await palmDescriptionGetAllForDropdown();
            if (res) {
                this.palmDescriptionOpts = res;
            }
        },
        async getPalmStatusOpts() {
            let res = await palmStatusGetAllForDropdown();
            if (res) {
                this.palmStatusOpts = res;
            }
        },
        async getAgencyOpts() {
            let res = await agenciesGetAllForDropdown();
            if (res) {
                this.agencyOpts = res;
            }
        },
        printQRCode() {
            this.$_printQRFromTable(this.selectionRow).then((res) => {
                if (res) {
                    this.qrInfo = res;
                    this.$nextTick(() => {
                        this.$_printQRList(this.qrCardContainerId, "PALM");
                    });
                }
            });
        },
    }
};
</script>

<style lang="css" scoped>
.title{
    color: var(--main-color-1);
    margin-bottom: var(--main-title-margin-btm);
}
.list-inner-container {
    display: flex;
    justify-content: space-between;
}
.list-container{
    padding: var(--container-padding);
}
.header-container{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: var(--space-10) 0;
}
.filter-title{
    display: inline-block;
    margin-right: var(--space-10);
}
.export-description {
    margin-bottom: 10px;
}
.filter-column-container {
    
}
.filter-column-container p{
    margin-bottom: var(--space-4);
}
.temp-button-container {
    display: flex;
    flex-direction: row;
}
.multiple-edit-button {
    margin-left: var(--space-12);
}
.reminder-text {
    color: var(--description-text);
    font-style: italic;
    font-size: 11px;
}
.downlaod-link {
    color: #409EFF
}
.downlaod-link:hover {
    text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/Palm/PalmTable.vue